import React from 'react';
import withInit from 'WithInit';
import JPGToPDFLandingPageFreeWriteBackgroundLayout from './JPGToPDFLandingPageFreeWriteBackgroundLayout';

class JPGToPDFLandingPage extends React.PureComponent {
  componentDidMount() {
    window.Upload.activateUploadButtonById('uploadPDFLarge');

    // Allow users to upload photos
    window.Upload.photoToPDF.init();
  }

  render() {
    return (
      <JPGToPDFLandingPageFreeWriteBackgroundLayout ctaId="uploadPDFLarge" />
    );
  }
}

export default withInit(JPGToPDFLandingPage);



// WEBPACK FOOTER //
// ./src-react/JPGToPDFLandingPage/index.jsx